import axios from "axios";
export default {
  namespaced: true,
  state: {
    all_units: [],
    pending_units: [],
    wip_units: [],
    pickup_units: [],
    cancelled_units: [],
    deleted_units: [],
  },
  getters: {
    all_units(state) {
      return state.all_units;
    },
    units(state) {
      return state.units;
    },
    unit_status(state) {
      return state.unit_status;
    },
    pending_units(state) {
      return state.pending_units;
    },
    wip_units(state) {
      return state.wip_units;
    },
    pickup_units(state) {
      return state.pickup_units;
    },
    cancelled_units(state) {
      return state.cancelled_units;
    },
    deleted_units(state) {
      return state.deleted_units;
    },
  },
  mutations: {
    SET_PENDING_UNITS(state, pending_units) {
      state.pending_units = pending_units;
    },
    REMOVE_PENDING_UNIT(state, problem_id) {
      state.pending_units = state.pending_units.filter((u) => {
        return u.id != problem_id;
      });
    },
    SET_WIP_UNITS(state, wip_units) {
      state.wip_units = wip_units;
    },
    ADD_WIP_UNIT(state, problem) {
      state.wip_units.unshift(problem);
    },
    REMOVE_WIP_UNIT(state, problem_id) {
      state.wip_units = state.wip_units.filter((u) => {
        return u.id != problem_id;
      });
    },
    SET_PICKUP_UNITS(state, pickup_units) {
      state.pickup_units = pickup_units;
    },
    ADD_PICKUP_UNIT(state, problem) {
      state.pickup_units.unshift(problem);
    },
    SET_CANCELLED_UNITS(state, cancelled_units) {
      state.cancelled_units = cancelled_units;
    },
    SET_ALL_UNITS(state, all_units) {
      state.all_units = all_units;
    },
    SET_UNIT_STATUS(state, unit_status) {
      state.unit_status = unit_status;
    },
    ADD_UNIT(state, unit) {
      state.all_units.unshift(unit);
    },
    SET_UNITS(state, units) {
      state.units = units;
    },
    UPDATE_UNIT(state, unit) {
      var index = state.all_units.findIndex((a) => a.id == unit.id);
      state.all_units.splice(index, 1, unit);
    },
    DELETE_UNIT(state, unit_id) {
      let filtered = state.all_units.filter((u) => {
        return u.id != unit_id;
      });
      state.all_units = filtered;
    },
    SET_DELETED_UNITS(state, deleted_units) {
      state.deleted_units = deleted_units;
    },
    RESTORE_UNIT(state, unit) {
      state.deleted_units = state.deleted_units.filter((u) => {
        return u.id != unit.id;
      });
      state.all_units.unshift(unit);
    },
  },
  actions: {
    async get_pending_units({ commit }) {
      let response = await axios.get("/unit_status/Pending");
      commit("SET_PENDING_UNITS", response.data);
    },
    async get_wip_units({ commit }) {
      let response = await axios.get("/unit_status/Work on Process");
      commit("SET_WIP_UNITS", response.data);
    },
    async get_pickup_units({ commit }) {
      let response = await axios.get("/unit_status/Ready to Pick-up");
      commit("SET_PICKUP_UNITS", response.data);
    },
    async get_cancelled_units({ commit }) {
      let response = await axios.get("/unit_status/Cancelled");
      commit("SET_CANCELLED_UNITS", response.data);
    },
    async start_working({ commit }, problem) {
      let response = await axios.post(
        "/problem/" + problem.id + "/start_working"
      );
      commit("REMOVE_PENDING_UNIT", problem.id);
      commit("ADD_WIP_UNIT", response.data);
      return response.data;
    },
    async ready_for_pickup({ commit }, problem) {
      let response = await axios.post(
        "/problem/" + problem.id + "/ready_for_pickup"
      );
      commit("REMOVE_PENDING_UNIT", problem.id);
      commit("REMOVE_WIP_UNIT", problem.id);
      commit("ADD_PICKUP_UNIT", response.data);
      return response.data;
    },
    async get_all_units({ commit }) {
      let response = await axios.get("/units");

      commit("SET_ALL_UNITS", response.data);
    },
    async get_unit_status({ commit }, type) {
      let response = await axios.get("unit_status/" + type);
      commit("SET_UNIT_STATUS", response.data);
    },
    async add_unit({ commit }, unit) {
      let response = await axios.post("/unit", unit);
      commit("ADD_UNIT", response.data);
    },
    async get_units({ commit }, customer_id) {
      let response = await axios.get("/units/" + customer_id);
      commit("SET_UNITS", response.data);
    },
    async update_unit({ commit }, unit) {
      let response = await axios.put("/unit", unit);
      commit("UPDATE_UNIT", response.data);
    },
    async delete_unit({ commit }, unit) {
      await axios.delete("/unit/" + unit.id);
      commit("DELETE_UNIT", unit.id);
    },
    async get_deleted_units({ commit }) {
      let response = await axios.get("/deleted_units");
      commit("SET_DELETED_UNITS", response.data);
    },
    async restore_unit({ commit }, unit) {
      let response = await axios.post("/unit/" + unit.id + "/restore");
      commit("RESTORE_UNIT", response.data);
    },
  },
};
